export const zendeskHelpConstants = {
  BASE_PATH: '/v1/help',
  ZENDESK_HOME_PAGE_URL: 'https://help.smata.com/hc/en-us',
};
